import { ICONS } from '@qlevr/shared/constants';
import { ProductInterface } from '@qlevr/shared/interfaces';
import { Accordion, AccordionContent, AccordionPanel, AccordionTitle, Flowbite, Modal } from 'flowbite-react';
import { useState } from 'react';
import { accordionTheme } from '../../content-blocks/accordion/accordion-theme';
import IconRenderer from '../../icons/icon-renderer.component';
import { premiumProductModalTheme } from '../product-premium-toggle/premium-product-modal-theme';
import { useTranslations } from 'next-intl';

export interface PersonalizedProductMoreInfoContentProps {
  openModal: boolean;
  setOpenModal: (isOpen: boolean) => void;
  product: ProductInterface;
}

export function PersonalizedProductMoreInfoContent({
  openModal,
  setOpenModal,
  product,
}: PersonalizedProductMoreInfoContentProps) {
  const t = useTranslations();
  const title = product.personalizedProductInformation?.title;
  const images = product.personalizedProductInformation?.images;
  const text1 = product.personalizedProductInformation?.text1;
  const text2 = product.personalizedProductInformation?.text2;
  const faqs = product.personalizedProductFaqs;

  const [accordionStates, setAccordionStates] = useState(faqs?.map(() => true));
  const handleClick = (index: number) => {
    setAccordionStates((prev) => prev?.map((state, i) => (i === index ? !state : true)));
  };

  return (
    <Modal
      dismissible
      size="md"
      theme={premiumProductModalTheme}
      show={openModal}
      position={'top-right'}
      onClose={() => setOpenModal(false)}
      className="modal-drawer-overlay bg-black/50 backdrop-blur-sm"
    >
      <Modal.Header>
        <span className="block text-left font-bold">{title}</span>
      </Modal.Header>
      <Modal.Body>
        <div className="space-y-4">
          <div className="space-y-4 px-4">
            {text1 && <div className="w-full" dangerouslySetInnerHTML={{ __html: text1 }} />}
            <div className="grid grid-cols-2 gap-2.5">
              {images?.map((image, key) => (
                <img src={image.url} className="aspect-square" loading="lazy" alt={image.altText || ''} key={key} />
              ))}
            </div>
            {text2 && <div className="w-full" dangerouslySetInnerHTML={{ __html: text2 }} />}
          </div>
          {faqs && (
            <div className="t-warm-bg space-y-2 px-4 pb-4 pt-6">
              <h2 className="text-2xl font-bold">{t('general.faq')}</h2>
              <Flowbite theme={{ theme: accordionTheme }}>
                <Accordion collapseAll>
                  {faqs.map((faq, index) => (
                    <AccordionPanel key={index}>
                      <div className="border-b border-teal-800 last:border-b-0">
                        <div className="flex justify-between" onClick={() => handleClick(index)}>
                          <AccordionTitle className="py-4">
                            <div className="flex w-full justify-between">
                              <div className="text-left">{faq.title}</div>
                              <div className="h-6 w-6 shrink-0 transform cursor-pointer">
                                {accordionStates?.[index] ? (
                                  <IconRenderer icon={ICONS.accordionClose} className="stroke-2" />
                                ) : (
                                  <IconRenderer icon={ICONS.accordionOpen} className="stroke-2" />
                                )}
                              </div>
                            </div>
                          </AccordionTitle>
                        </div>
                        <AccordionContent>
                          {faq.text && (
                            <div className="w-full pb-4 font-normal" dangerouslySetInnerHTML={{ __html: faq.text }} />
                          )}
                        </AccordionContent>
                      </div>
                    </AccordionPanel>
                  ))}
                </Accordion>
              </Flowbite>
            </div>
          )}
        </div>
      </Modal.Body>
    </Modal>
  );
}

export default PersonalizedProductMoreInfoContent;
